import { gql } from '@apollo/client';

export const GET_TABLES_LIST = gql`
  query Tables($params: FindTableListInput!) {
    tables(params: $params) {
      success
      message
      errors
      data {
        tables {
          id
          schemaId
          schemaName
          tableName
          description
          purpose
          primaryKeyColumns
          keywords
          businessContext
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_TABLE = gql`
  query Table($params: FindTableInput!) {
    table(params: $params) {
      success
      message
      errors
      data {
        id
        schemaId
        schemaName
        tableName
        description
        purpose
        primaryKeyColumns
        keywords
        businessContext
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
